import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { NormalizedV2Response } from '@/types/eds/api/responses/NormalizedV2Response';

export type PartyPaymentInformationState = {
  partyPaymentInformationIsLoading: boolean;
  partyPaymentInformationNormalizedData: NormalizedV2Response[];
};

const initialState: PartyPaymentInformationState = {
  partyPaymentInformationIsLoading: false,
  partyPaymentInformationNormalizedData: [],
};

const partyPaymentInformationSlice = createSlice({
  name: 'partyPaymentInformation',
  initialState,
  reducers: {
    getPartyPaymentInformationData: (state, _action: PayloadAction<{ partyId: string }>) => {
      state.partyPaymentInformationIsLoading = true;
    },
    getPartyPaymentInformationDataSuccess: (
      state,
      action: PayloadAction<{ partyPaymentInformationNormalizedData: NormalizedV2Response[] }>,
    ) => {
      state.partyPaymentInformationNormalizedData = action.payload.partyPaymentInformationNormalizedData;
      state.partyPaymentInformationIsLoading = false;
    },
  },
  selectors: {
    selectPartyPaymentInformationIdLoading: (state) => state.partyPaymentInformationIsLoading,
    selectPartyPaymentInformationData: (state) => state.partyPaymentInformationNormalizedData,
  },
});

export const { getPartyPaymentInformationData, getPartyPaymentInformationDataSuccess } =
  partyPaymentInformationSlice.actions;
export const { selectPartyPaymentInformationIdLoading, selectPartyPaymentInformationData } =
  partyPaymentInformationSlice.selectors;

export const partyPaymentInformationReducer = partyPaymentInformationSlice.reducer;
export const partyPaymentInformationReducerPath = partyPaymentInformationSlice.reducerPath;
